import { formatMoney } from "~/utils/formatMoney"
import moment from "moment"
import stripeIntentUrlFor from "~/utils/admin/stripeIntentUrlFor"
import baseUrl from "~/utils/admin/baseUrl"

const PaymentsTable = ({ data, camp }) => {
  return (
    <table className="min-w-full table-auto divide-y divide-gray-300">
      <thead className="sticky top-0 bg-white shadow-sm">
      <tr>
        <th
          scope='col'
          className='py-3.5 w-1/12 text-left text-base font-semibold text-gray-900 whitespace-nowrap'>
          Created Date
        </th>
        <th
          scope='col'
          className='pr-5 pl-1 w-1/12 text-left text-base font-semibold text-gray-900 whitespace-nowrap'>
          Mode
        </th>
        <th
          scope='col'
          className='pr-5 pl-1 w-1/12 text-left text-base font-semibold text-gray-900 whitespace-nowrap'>
          Kind
        </th>
        <th
          scope='col'
          className='pr-5 pl-1 w-1/12 text-left text-base font-semibold text-gray-900 whitespace-nowrap'>
          Invoice
        </th>
        <th
          scope='col'
          className='pr-5 pl-1 w-1/12 text-left text-base font-semibold text-gray-900 whitespace-nowrap'>
          Stripe ID
        </th>
        <th
          scope='col'
          className='pr-5 pl-1 w-1/12 text-left text-base font-semibold text-gray-900 whitespace-nowrap'>
          Site Name
        </th>
        <th
          scope='col'
          className='pr-5 pl-1 w-1/12 text-left text-base font-semibold text-gray-900 whitespace-nowrap'>
          Site Type
        </th>
        <th
          scope='col'
          className='pr-5 pl-1 w-1/12 text-left text-base font-semibold text-gray-900 whitespace-nowrap'>
          Customer Name
        </th>
        <th
          scope='col'
          className='py-3.5 w-1/12 text-left text-base font-semibold text-gray-900 whitespace-nowrap'>
          Booking Start Date
        </th>
        <th
          scope='col'
          className='pr-5 pl-1 w-1/12 text-left text-base font-semibold text-gray-900 whitespace-nowrap'>
          Duration
        </th>
        <th
          scope='col'
          className='pr-5 pl-1 w-1/12 text-left text-base font-semibold text-gray-900 whitespace-nowrap'>
          Amount
        </th>
        <th
          scope='col'
          className='pr-5 pl-1 w-1/12 text-left text-base font-semibold text-gray-900 whitespace-nowrap'>
          Application Fee
        </th>
        <th
          scope='col'
          className='pr-5 pl-1 w-1/12 text-left text-base font-semibold text-gray-900 whitespace-nowrap'>
          Stripe Fee
        </th>
        <th
          scope='col'
          className='pr-5 pl-1 w-1/12 text-left text-base font-semibold text-gray-900 whitespace-nowrap'>
          Taxes (included in Net)
        </th>
        <th
          scope='col'
          className='pr-5 pl-1 w-1/12 text-left text-base font-semibold text-gray-900 whitespace-nowrap'>
          Net Amount
        </th>
      </tr>
      </thead>
      <tbody className="divide-y divide-gray-200 bg-white">
        {data &&
          data.map((paymentData, index) => {
            const {
              created_at,
              mode,
              kind,
              invoice_number,
              stripe_id,
              site_name,
              site_type,
              customer_full_name,
              reservation_start_date,
              duration,
              amount,
              application_fee,
              stripe_fee,
              tax_fee,
              net
            } = paymentData

            return (
              <tr className='h-10'>
                <td className='pl-3 text-gray-500 whitespace-nowrap'>
                {moment(created_at).format('YYYY-MM-DD HH:mm:ss')}
                </td>
                <td className='pl-3 text-gray-500 whitespace-nowrap'>{mode}</td>
                <td className='pl-3 text-gray-500 whitespace-nowrap'>{kind}</td>
                <td className='pl-3 text-gray-500 whitespace-nowrap'>
                  <a href={`${baseUrl()}/i/${invoice_number}`} target="_blank">{invoice_number}</a>
                </td>
                <td className='pl-3 text-gray-500 whitespace-nowrap'>
                  <a
                    href={stripeIntentUrlFor(
                      camp.stripe_account_id,
                      stripe_id
                    )}
                    target="_blank">
                    {stripe_id}
                  </a>
                </td>
                <td className='pl-3 text-gray-500 whitespace-nowrap'>{site_name}</td>
                <td className='pl-3 text-gray-500 whitespace-nowrap'>{site_type}</td>
                <td className='pl-3 text-gray-500 whitespace-nowrap'>{customer_full_name}</td>
                <td className='pl-3 text-gray-500 whitespace-nowrap'>
                  {reservation_start_date ? moment(reservation_start_date).format('YYYY-MM-DD') : ''}
                </td>
                <td className='pl-3 text-gray-500 whitespace-nowrap'>{duration}</td>
                <td className='text-gray-500 text-right whitespace-nowrap'>
                  {formatMoney(amount, camp?.currency)}
                </td>
                <td className='text-gray-500 text-right whitespace-nowrap'>
                  {formatMoney(application_fee, camp?.currency)}
                </td>
                <td className='text-gray-500 text-right whitespace-nowrap'>
                {typeof stripe_fee === 'string' ? stripe_fee : formatMoney(stripe_fee, camp?.currency)}
                </td>
                <td className='text-gray-500 text-right whitespace-nowrap'>
                  {typeof tax_fee === 'string' ? tax_fee : formatMoney(tax_fee, camp?.currency)}
                </td>
                <td className='text-gray-500 text-right whitespace-nowrap'>
                  {formatMoney(net, camp?.currency)}
                </td>
              </tr>
            )
          })}
      </tbody>
    </table>
  )
}

export default PaymentsTable
